
function answers(state = {}, action) {
  switch (action.type) {
    case 'TOGGLE_STATEMENT':
      const COST_OF_NOT_ANSWER = action.availablePoints / action.answers.length;
      if (action.remainingPoints < COST_OF_NOT_ANSWER && state[action.evalId][action.statementId].enabled) {
        return state;
      }

      const enabled = !state[action.evalId][action.statementId].enabled;
      const value = enabled ? 0 : COST_OF_NOT_ANSWER;
      const enabledState = { ...state[action.evalId][action.statementId], enabled, value };

      return nestAnswers(state, action.evalId, [enabledState]);
    case 'SLIDER_CHANGED' : {
      const answerIndex = action.answers.map(a => a.statement_id).indexOf(action.id);
      const answerValues = action.answers;

      const values = getSliderValues(action.value, answerIndex, answerValues);

      return nestAnswers(state, action.eval, values);
    }
    case 'SAVE_ANSWERS' :
      return nestAnswers(state, action.eval, action.answers);
    case 'DATA_RECEIVED' : {
      const answersToState = {};
      const answersFromServer = action.data.answers;
      Object.keys(answersFromServer).forEach(key => {
        answersToState[key] = {};
        Object.keys(answersFromServer[key]).forEach(key2 => {
          answersToState[key][key2] = {
            ...answersFromServer[key][key2],
            value: answersFromServer[key][key2].value,
            lock: 'unlock'
          };
        });
      });

      return answersToState;
    }
    default:
      return state;
  }
}

const getSliderValues = (value, index, stateArray) => stateArray.map((q, j) => {
  if (j === index) {
    return { ...q, value };
  }
  return { ...q };

});

const nestAnswers = (nestedObject, key, newValues) => {
  const newObject = { ...nestedObject };
  newValues.forEach(v => {
    if (!newObject[key]) {
      newObject[key] = {};
    }
    newObject[key][v.statement_id] = v;
  });
  return newObject;
};

export default answers;
